/* Header nav: stop "Contact" wrapping onto a second row.
   --------------------------------------------------------------------------
   THE ORIGINAL BUG
   Horizon collapses links that don't fit into a "More" button using its
   <overflow-list> element. That element measures the items ONCE and then only
   re-measures when its own width changes, via a ResizeObserver on itself.

   Which loses a race with the webfonts. At first paint the links are laid out
   in the fallback font and are narrower, so everything "fits" and nothing gets
   collapsed. The webfont then loads, every link grows, and the last one wraps
   onto a second row. The list's own width never changed, so the observer never
   fires and it stays broken until the window is resized. On the builder page
   that stray link landed on top of the options panel, which is how this was
   first spotted.

   THE BUG THE FIRST FIX CAUSED
   That version forced a re-measure by shaving a pixel off the element's width
   and putting it back 250ms later, and it did this three times on every page
   load, unconditionally. Two problems:

     - the width genuinely changes, so at any viewport width where the list is
       borderline, losing a pixel is enough to tip the last item into "More"
       and giving it back tips it out again. Visibly: the nav flickers between
       a link and "More", three times, on every single page load.
     - it ran even when nothing was wrong, which is most of the time.

   THE FIX NOW
   Two changes, and the flicker is gone:

     1. DO NOTHING UNLESS IT IS ACTUALLY BROKEN. `wrapped()` checks whether any
        visible item sits on a different row from the first. On a healthy nav
        this returns false and the script touches nothing at all.

     2. ASK THE COMPONENT TO RE-MEASURE instead of tricking it. <overflow-list>
        exposes schedule() on its prototype - its own re-layout entry point.
        Calling it recomputes without mutating any geometry, so there is
        nothing to flicker. Verified against the live element: it is a real
        function, it runs clean, and it leaves a healthy nav untouched.

   The width nudge survives only as a last resort, for the case where
   schedule() exists but did not resolve the wrap - and even then it fires once,
   on a nav that is already visibly broken.
   -------------------------------------------------------------------------- */
(function navOverflowFix() {
  var RESTORE_MS = 250; /* must outlast a layout pass, or the two width
                           changes coalesce and the observer never fires */
  var ROW_TOLERANCE = 4; /* px of baseline wobble that is not a new row */

  function wrapped(el) {
    var items = el.querySelectorAll('li');
    var firstTop = null;

    for (var i = 0; i < items.length; i++) {
      var r = items[i].getBoundingClientRect();
      if (r.height === 0) continue; /* already tucked into the overflow slot */
      if (firstTop === null) {
        firstTop = r.top;
      } else if (Math.abs(r.top - firstTop) > ROW_TOLERANCE) {
        return true;
      }
    }
    return false;
  }

  /* Last resort only. Changing the width is what the old version did on every
     load; it is visible, so it is now reserved for a nav that is already
     wrong and did not respond to schedule(). */
  function nudge(el) {
    var w = el.getBoundingClientRect().width;
    if (!w) return;
    el.style.width = w - 1 + 'px';
    setTimeout(function () {
      el.style.width = '';
    }, RESTORE_MS);
  }

  function fix(el) {
    if (!wrapped(el)) return;

    if (typeof el.schedule === 'function') {
      try {
        el.schedule();
      } catch (e) {
        nudge(el);
        return;
      }
      /* Two frames: one for schedule() to run, one for layout to settle. */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (wrapped(el)) nudge(el);
        });
      });
      return;
    }

    nudge(el);
  }

  function sweep() {
    var lists = document.querySelectorAll('overflow-list');
    for (var i = 0; i < lists.length; i++) fix(lists[i]);
  }

  /* The one that actually matters - this is the moment the metrics change. */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(sweep);
  }

  /* Late stylesheets, and a slow font server. Both are no-ops on a healthy
     nav now, so running them costs nothing. */
  window.addEventListener('load', sweep);
  setTimeout(sweep, 1500);

  window.__pmNav = { sweep: sweep, wrapped: wrapped };
})();